import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { Button } from "../catalyst/button";

interface BackButtonProps {
  className?: string;
  onClick?: () => void;
}

export default function BackButton({ className, onClick }: BackButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      plain
      onClick={handleClick}
      className={className}
      buttonClassName="*:data-[slot=icon]:size-6 sm:*:data-[slot=icon]:size-6"
    >
      <ArrowLeftIcon />
      <span className="sr-only">Go back</span>
    </Button>
  );
}
